import { ChangeDetectionStrategy, Component } from '@angular/core';
import { COMPANY_ASYNC_EXPORT_SERVICE_CONFIG, CompanyAsyncExportModule } from '../../../../shared/components';
import { CompanyHsAsyncExportService } from './company-hs-async-export.service';

@Component({
    template: `
		<app-company-async-export></app-company-async-export>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{
            provide: COMPANY_ASYNC_EXPORT_SERVICE_CONFIG,
            useClass: CompanyHsAsyncExportService,
        }],
    imports: [
        CompanyAsyncExportModule
    ]
})
export class CompanyHsAsyncExportComponent {}
